<template>
  <div class="chart">
    <highcharts :options="chartOptions" :updateArgs="updateArgs" ref="myChart"></highcharts>
  </div>
</template>

<script>
var moment = require("moment");
export default {
  props: ["chartData", "newData", "lastClose", "fills", "tradeType", "zones"],
  data() {
    return {
      moment: moment,
      updateArgs: [true, true, { duration: 300 }],
      chartOptions: {
        chart: {
          backgroundColor: "#28303D",
          marginRight: 50,
          height: 370
        },
        title: {
          text: ""
        },
        xAxis: [
          {
            lineWidth: 0,
            minorGridLineWidth: 0,
            lineColor: "transparent",
            minorTickLength: 0,
            tickLength: 0,
            gridLineWidth: 1,
            gridLineColor: "rgba(128, 143, 156, 0.1)",
            type: "datetime",
            labels: {
              align: "left",
              x: -10,
              style: {
                color: "#808F9C",
                fontSize: "10px",
                fontFamily: "Roboto, sans-serif"
              }
            },
            crosshair: {
              zIndex: 30,
              width: 1,
              dashStyle: "dash",
              color: "rgba(128, 143, 156, 0.3)",
              snap: false,
              label: {
                enabled: true,
                padding: 3,
                format: "{value:%H:%M:%S}",
                style: {
                  color: "white",
                  fontSize: "12px",
                  fontFamily: "Roboto, sans-serif"
                }
              }
            }
          }
        ],
        yAxis: [
          {
            plotBands: [],
            title: "",
            gridLineWidth: 0,
            opposite: true,
            resize: {
              enabled: false
            },
            crosshair: {
              zIndex: 30,
              width: 1,
              dashStyle: "dash",
              color: "rgba(128, 143, 156, 0.3)",
              snap: false,
              label: {
                adjustToOffset: true, // New param
                enabled: true,
                padding: 3,
                offset: -60,
                zIndex: 30,
                formatter: function(value) {
                  return (Math.ceil(value / 0.25) * 0.25).toFixed(2);
                },
                style: {
                  color: "white",
                  fontSize: "12px",
                  fontFamily: "Roboto, sans-serif",
                  zIndex: 30
                }
              }
            },
            offset: 100,
            labels: {
              distance: 0,
              align: "left",
              format: "{value:.2f}",
              style: {
                color: "#808F9C",
                fontSize: "10px",
                fontFamily: "Roboto, sans-serif"
              },
              y: 6,
              x: 18
            }
          }
        ],
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              style: {
                fontWeight: "bold",
                color: "#ffffff",
                textOutline: 0
              },
              formatter: function() {
                return null;
              }
            },
            animations: false
            //cursor: 'pointer',
          },
          flags: {
            fillColor: "transparent",
            color: "transparent",
            //y: 0,
            //x: 0,
            //yAxis: 50,
            style: { fontSize: "11px", color: "white" }
          },
          line: {
            color: "#808F9C",
            marker: {
              enabled: false
            }
          },
          ohlc: {
            color: "#808F9C",
            lineWidth: 1
          },
          scatter: {
            color: "#ffffff",
            //lineWidth: 20,
            marker: {
              radius: 4,
              symbol: "circle"
            }
          },
          column: {
            dataGrouping: {
              enabled: false
            }
          },
          bubble: {
            tooltip: {
              shared: false,
              pointFormat:
                '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
              //'{point.y}'
            },
            minSize: 20,
            maxSize: 30,

            dataLabels: {
              inside: true,
              enabled: true,
              format: "{point.z}"
            }
            //cursor: "pointer"
          }
        },
        tooltip: {
          backgroundColor: "#28303D",
          style: {
            fontFamily: "Roboto, sans-serif",
            color: "#808F9C",
            fontSize: "11px",
            fontWeight: "light"
          },
          shape: "square",
          headerShape: "callout",
          borderWidth: 0,
          shadow: false,
          positioner: function(width, height, point) {
            var chart = this.chart,
              position;
            if (point.isHeader) {
              position = {
                x: Math.max(
                  // Left side limit
                  chart.plotLeft,
                  Math.min(
                    point.plotX + chart.plotLeft - width / 2,
                    // Right side limit
                    chart.chartWidth - width - chart.marginRight
                  )
                ),
                y: point.plotY
              };
            } else {
              position = {
                x: point.series.chart.plotLeft,
                y: point.series.yAxis.top - chart.plotTop
              };
            }
            return position;
          },
          formatter: function() {
            return (
              "<b>" +
              "Date: " +
              moment(new Date(this.x)).format("H:mm:ss") +
              " O: " +
              this.y.toFixed(2) +
              " H: " +
              this.y.toFixed(2)
            );
          }
        },
        credits: { enabled: false },
        legend: { enabled: false },
        series: [
          {
            animation: true,
            enableMouseTracking: false,
            //data: this.$store.state.highchartsData,
            data: [],
            type: "line"
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "scatter"
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "flags"
          },
          {
            animation: false,
            enableMouseTracking: false,
            data: [],
            type: "scatter",
            color: "#28303D",
            marker: {
              radius: 1,
              symbol: "circle"
            }
          },
          {
            type: "bubble",
            animation: false,
            enableMouseTracking: false,
            data: [],
            boostBlending: "alpha",
            turboThreshold: 0,
            boostThreshold: 1,
            fillOpacity: 1

            //color: "#E62163"

            /*
            marker: {
              radius: 10,
              symbol: "circle"
            },
            color: "#E62163",
            */
          }
        ]
      }
    };
  },
  /*
  watch: {
    title (newValue) {
      this.chartOptions.title.text = newValue
    },
    points (newValue) {
      this.chartOptions.series[0].data = newValue
    },
    chartType (newValue) {
      this.chartOptions.chart.type = newValue.toLowerCase()
    },
    seriesColor (newValue) {
      this.chartOptions.series[0].color = newValue.toLowerCase()
    },
    animationDuration (newValue) {
      this.updateArgs[2].duration = Number(newValue)
    }
  },
  */
  methods: {
    zonesData() {
      var colors = {Long: "rgba(0,255,0,0.2)", Short: "rgba(255,0,0,0.2)", Neutral: "rgba(0,0,0,0.1)"}

      this.zones.forEach(zone => {
        var data = {
          color: colors[zone.type],
          from: zone.low,
          to: zone.high,
          zIndex: 1
        };
        this.chartOptions.yAxis[0].plotBands.push(data)
      });

      
    },
    updateFills() {
      var colorRed = "#E62163";
      var colorGreen = "#79C04D";

      var bubbleColor = colorGreen;
      if (this.tradeType == 1) {
        bubbleColor = colorRed;
      }

      var fillsData = [];
      this.fills.forEach(element => {
        if (this.tradeType == 1) {
          if (element.volume < 0) {
            bubbleColor = colorGreen;
          } else {
            bubbleColor = colorRed;
          }
        } else {
          if (element.volume < 0) {
            bubbleColor = colorRed;
          } else {
            bubbleColor = colorGreen;
          }
        }

        fillsData.push({
          x: parseInt(element.time),
          y: parseFloat(element.price),
          z: parseInt(Math.abs(element.volume)),
          color: bubbleColor
          //fillColor : "#79C04D"
        });
      });
      this.chartOptions.series[4].data = [];
      //data.reverse();

      //this.$store.dispatch("ADD_DATA", socketData)
      this.chartOptions.series[4].data = fillsData;
    },

    addNewData() {
      //this.chartOptions.series[0].data.splice(0, 1);
      this.chartOptions.series[0].data.push([
        parseInt(this.newData.time),
        parseFloat(this.newData.close)
      ]);
    },

    updateClose() {
      this.chartOptions.series[0].data[
        this.chartOptions.series[0].data.length - 1
      ][1] = this.lastClose;
      this.chartOptions.series[2].data = [
        {
          x: parseInt(this.chartData[this.chartData.length - 1].time),
          y: this.lastClose,
          title: this.lastClose.toFixed(2).toString()
        }
      ];
      this.chartOptions.series[3].data = [
        {
          x: parseInt(this.chartData[this.chartData.length - 1].time + 200000),
          y: this.lastClose
        }
      ];
      this.chartOptions.series[1].data = [
        {
          x: parseInt(this.chartData[this.chartData.length - 1].time),
          y: this.lastClose
        }
      ];
    },

    historyData() {
      var historyData = [];
      this.chartData.forEach(element => {
        historyData.push([parseInt(element.time), parseFloat(element.close)]);
      });
      //alert("davam")
      //this.chartOptions.series[0].data.push([1600000000000,8000]);
      this.chartOptions.series[0].data = [];
      //data.reverse();

      //this.$store.dispatch("ADD_DATA", socketData)
      this.chartOptions.series[0].data = historyData;

      this.chartOptions.series[2].data = [
        {
          x: parseInt(this.chartData[this.chartData.length - 1].time),
          y: parseFloat(this.chartData[this.chartData.length - 1].close),
          title: parseFloat(this.chartData[this.chartData.length - 1].close)
            .toFixed(2)
            .toString()
        }
      ];

      this.chartOptions.series[3].data = [
        {
          x: parseInt(this.chartData[this.chartData.length - 1].time + 200000),
          y: parseFloat(this.chartData[this.chartData.length - 1].close)
        }
      ];
      this.chartOptions.series[1].data = [
        {
          x: parseInt(this.chartData[this.chartData.length - 1].time),
          y: parseFloat(this.chartData[this.chartData.length - 1].close)
        }
      ];
      //this.chartOptions.series[2].data.push(data[data.length - 1]);
      /*
      this.chartOptions.series[3].data = [
        {
          x: data[data.length - 1][0],
          y: data[data.length - 1][1],
          title: data[data.length - 1][1]
        }
      ];
      */
    }
  },
  mounted() {
    this.historyData();
    this.updateFills();
    this.zonesData();
  },
  sockets: {
    /*
    data: function(data) {
      //this.redraw(data);
      this.$store.commit("ADD_DATA", data);
      alert(data);
    },
    
    addData: function(data) {
      //this.addData(data);

    alert(data[1]);
    }
    */
  },
  computed: {
    activeChart() {
      return this.$store.state.chartData;
    }
  },
  watch: {
    zones() {
      this.zonesData();
    },
    chartData() {
      //this.historyData()
    },
    lastClose() {
      this.updateClose();
    },
    fills() {
      //alert(this.fills[0].price)
      this.updateFills();
    },
    newData() {
      this.addNewData();
    }
  }
};
</script>

<style scoped>
.chart {
  float: left;
  width: 100%;
  padding: 5px 0px 5px 5px;
  cursor: crosshair;
}
</style>


